import { Link } from "react-router-dom";

const FeaturedOne = ({
  title,
  descriptionLine1,
  descriptionLine2,
  direction,
  showBtn,
  btn1Text,
  btn2Text,
  img,
  isContainer,
  withoutPadding,
  isGradient
}) => {
  const isRight = direction === "text-right";
  return (
    <section className={`featured-product   position-relative z-index-1 ${withoutPadding ? "" : "padding-y-120"} ${isGradient ? "section-bg" : ""}`}>
      {isGradient && <img src="/assets/images/gradients/tamias-about-gradient.png" alt="" className="bg--gradient" />}
      <div className={`overflow-hidden ${isContainer ? "container" : ""}`}>
        <div
          className={`row gy-4 align-items-center flex-wrap  ${
            isRight ? "flex-row-reverse flex-wrap-reverse" : ""
          }`}
        >
          {/* <div className="row gy-4 flex-wrap-reverse flex-row-reverse align-items-center"> */}
          <div className="col-xl-6">
           
            <img src={img} alt="hero-img" />
          </div>
          <div className="col-xl-1 d-xl-block d-none" />
          <div className="col-xl-5">
            <div className="section-content container">
              <div className="section-heading style-left">
                <h3 className="section-heading__title">{title}</h3>
                <p className="section-heading__desc font-18 w-sm">
                  {descriptionLine1}
                </p>
                <p className="section-heading__desc font-18 w-sm">
                  {descriptionLine2}
                </p>
              </div>
              {showBtn && (
                <div className="featured-buttons">
                <Link
                  to="https://apps.apple.com/bf/app/on-time-queue/id6479869608"
                  target="_blank"
                  className="btn btn-green btn-lg pill fw-300"
                >
                  {btn1Text}
                </Link>
                <Link
                  to="https://play.google.com/store/apps/details?id=com.ontimequeue"
                  target="_blank"
                  className="btn btn-green btn-lg pill fw-300"
                >
                  {btn2Text}
                </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedOne;

